import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Admin-overstyring av biltall (nyttelast, mål, beskrivelse) fra settings/truckCatalog, feltet specs:
// { 'tipper-3': { payloadTons: 14 }, ... }. Feiler lesingen, brukes standardverdiene i koden.
export function useTruckCatalog() {
  const [overrides, setOverrides] = useState({});
  useEffect(() => {
    let cancelled = false;
    Promise.resolve(getDoc(doc(db, 'settings', 'truckCatalog')))
      .then(snap => {
        if (cancelled || !snap?.exists?.()) return;
        const specs = snap.data()?.specs;
        if (specs && typeof specs === 'object') setOverrides(specs);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return overrides;
}
